export const jaJP = {
  translation: {
    header: {
      title: "こんにちは",
      tips_one: "ページは{{count}}回閲覧されました",
      tips_other: "ページは{{count}}回閲覧されました",
      tips_zero: "まだ閲覧されていません",
    },
    date: "今日は{{date, DATE_HUGE}}",
  },
};
